import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Table, Tr } from 'reactable';
import isEmpty from 'lodash/isEmpty';
import makeLoanRepaymentReport from './makeLoanRepaymentReport';

const Report = ({ timezone, reportData }) => (
  <div>
    {isEmpty(reportData) ? <div>No data available for loan</div> : null}
    <Table
      className="c-table"
    >
      <Tr
        className="special-row"
        data={makeLoanRepaymentReport(reportData, timezone)}
      />
    </Table>
  </div>
);

const mapStateToProps = state => ({
  reportData: state.reports.loanRepaymentReport,
  timezone: state.auth.timezone,
});

Report.propTypes = {
  reportData: PropTypes.instanceOf(Array).isRequired,
  timezone: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(Report);
